<template>
  <div>
    <div
      v-for="response in responses"
      :key="response.Grant_Application_Response_Id"
    >
      <strong v-if="showCategory" class="d-block mb-2 mt-4">{{
        response.Application_Template_Response
          .Application_Template_Response_Category.Category
      }}</strong>
      <div class="row">
        <div class="col-auto pr-0">
          <i
            class="pointer material-icons text-danger"
            v-on:click="removeApplicationResponse(response)"
          >
            clear
          </i>
        </div>
        <div class="col pl-1">
          <p
            class="d-inline"
            v-for="responseTextChunk in generateResponseChunks(response)"
            :key="responseTextChunk.blankNumber"
            style="white-space: pre-wrap;"
          >
            {{ responseTextChunk.text }}
            <button
              v-if="responseTextChunk.blankNumber != -1"
              class="btn btn-sm btn-outline-secondary py-0 mb-1 text-left"
              v-on:click="fillInBlank(response, responseTextChunk.blankNumber)"
            >
              <u
                >{{
                  getResponseAnswer(
                    response.Grant_Application_Response_Answers,
                    responseTextChunk.blankNumber
                  )
                }}
                {{ response.blankNumber }}</u
              >
            </button>
          </p>
        </div>
      </div>
    </div>
    <p class="mt-4" v-if="responses.length == 0">
      {{ noResponsesText }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ResponsesToShow",
  props: {
    Responses: Array,
    NoResponsesText: String,
    ShowCategory: Boolean
  },
  data() {
    return {
      responses: this.Responses,
      noResponsesText: this.NoResponsesText,
      showCategory: this.ShowCategory != null ? this.ShowCategory : true
    };
  },
  watch: {
    Responses: function() {
      this.responses = this.Responses;
    }
  },
  methods: {
    generateResponseChunks(response) {
      var responseText = response.Application_Template_Response.Response;
      var blankNumbers = responseText.match(
        /[@]blank-\d+[@](?:hint:[^@]*[@])?/g
      );
      var responseChunks = [];
      var splitText = responseText.split(/[@]blank-\d+[@](?:hint:[^@]*[@])?/g);
      for (var i = 0; i < splitText.length - 1; i++) {
        responseChunks.push({
          text: splitText[i],
          blankNumber: blankNumbers[i].match(/\d+/)[0]
        });
      }
      responseChunks.push({
        text: splitText[splitText.length - 1],
        blankNumber: -1
      });
      return responseChunks;
    },
    fillInBlank(response, blankNumber) {
      var responseBlankToEdit = {
        response: response,
        blankNumber: blankNumber
      };
      this.$emit("fillInBlank", responseBlankToEdit);
    },
    getResponseAnswer(responseAnswers, blankNumber) {
      var blankAnswer =
        responseAnswers.length > 0
          ? responseAnswers.find(
              a => a.Template_Response_Blank_Answer.Blank_Number == blankNumber
            )
          : null;
      var answer = blankAnswer
        ? blankAnswer.Template_Response_Blank_Answer
        : null;
      var answerText = answer ? answer.Answer : `fill in the blank here`;
      return answerText.trim();
    },
    async removeApplicationResponse(response) {
      this.$store.commit("updateLoading", true);
      await this.$removeGrantApplicationResponse(
        response.Grant_Application_Response_Id
      );
      this.$store.commit("updateLoading", false);
      this.$emit("removedApplicationResponse", response);
    }
  }
};
</script>
